import { FormikErrors } from 'formik'
import { useJsApiLoader } from '@react-google-maps/api'

import {
  GoogleMapAutocomplete,
  FormGoogleMap,
  GoogleMapLatAndLongInput,
  HelperWrapper,
} from 'src/components'
import { ETranslationNs, IAccountFormCreate } from 'src/types'
import { jsApiLoaderOptions } from 'src/constants'

import useStyles from './styles'
import { useTranslation } from 'react-i18next'

interface Props {
  errors: FormikErrors<IAccountFormCreate>
  address: string
  handleAddress: (val: string) => void
  handleLatitudeAndLongitude: (center: { lat: number; lng: number }) => void
  centerProp: {
    lat: number
    lng: number
  }
}

const Address = ({
  errors,
  address,
  handleAddress,
  centerProp,
  handleLatitudeAndLongitude,
}: Props) => {
  const classes = useStyles()
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { isLoaded } = useJsApiLoader(jsApiLoaderOptions)

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        <HelperWrapper t="account-form-address-label" isColorInherited />
      </p>
      {isLoaded && (
        <GoogleMapAutocomplete
          address={address}
          handleAddress={handleAddress}
          handleLatAndLong={handleLatitudeAndLongitude}
          error={errors.address ? t(`${errors.address}.v`) : ''}
        />
      )}
      <GoogleMapLatAndLongInput
        isRequired={!!address}
        center={centerProp}
        handleAddress={handleAddress}
        handleLatAndLong={handleLatitudeAndLongitude}
      />
      {isLoaded && (
        <div className={classes.mapWrapper}>
          <FormGoogleMap
            handleLatAndLong={handleLatitudeAndLongitude}
            center={centerProp}
            handleAddress={handleAddress}
          />
        </div>
      )}
    </div>
  )
}

export { Address }
